import Box from "@mui/material/Box";

import { PANEL } from "@plannel/components/ui/SidePanel";
import useResizableWidth, { ResizeHandle, PANEL_MIN_WIDTH, PANEL_DEFAULT_WIDTH } from "@plannel/components/ui/useResizableWidth";

/*
 * 고급 필터가 앉는 자리 — 왼쪽 드래그 손잡이 + 폭을 가진 카드.
 *
 * 폭 조절은 원래 DP Workbench·RP 몇 화면에만 있었고(각자 state·effect 를 복사해 두고 있었다),
 * 나머지 50여 화면은 `width: 30%` 로 고정이라 조절할 수 없었다. 그 두 벌을 여기 하나로 모은다.
 *
 *   <Box sx={{ display: "flex" }}>        ← 부모는 flex row 여야 한다(손잡이와 카드가 형제로 선다)
 *     …그리드…
 *     {openFilter && (
 *       <ResizableFilterPanel>
 *         <AdvancedFilter … />
 *       </ResizableFilterPanel>
 *     )}
 *   </Box>
 *
 * 룩은 우측 패널 3종(SidePanel)과 같은 카드다 — radius 14 + 같은 그림자.
 * 예전의 `border: 1px #cccccc` 각진 상자는 같은 화면 안에서 혼자 다른 규격이었다.
 * 드래그 규칙 자체는 SidePanel 도 같이 쓰는 useResizableWidth 에 있다.
 */

const ResizableFilterPanel = ({ defaultWidth = PANEL_DEFAULT_WIDTH, minWidth = PANEL_MIN_WIDTH, sx, children }) => {
  const { width, resizing, nodeRef, startResize } = useResizableWidth({ defaultWidth, minWidth });

  return (
    <>
      <ResizeHandle onMouseDown={startResize} active={resizing} />
      <Box
        ref={nodeRef}
        sx={{
          flex: "none",
          width: `${width}px`,
          minWidth,
          height: "100%",
          maxHeight: "100%",
          overflowY: "auto",
          bgcolor: "#fff",
          borderRadius: PANEL.radius,
          boxShadow: PANEL.shadow,
          ...sx,
        }}
      >
        {children}
      </Box>
    </>
  );
};

export default ResizableFilterPanel;
